import React, { useEffect, useState } from "react"
import Carousel from "react-multi-carousel"
import clsx from "clsx"

import { BannerData } from "@interfaces/misc"
import { Container } from "@components/wrapper"
import { Skeleton } from "@components/misc"
import { SliderArrow, SliderDot } from "@components/slider"
import CommonServices from "@services/common.services"
import Image from "next/image"

export const HomeBanner = ({ screenWidth }: { screenWidth: number }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [bannerList, setBannerList] = useState<BannerData[]>([])
  const common = new CommonServices()

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 30,
    },
    tablet: {
      breakpoint: { max: 768, min: 464 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  useEffect(() => {
    const getData = async () => {
      try {
        const banner = await common.getBannerList()
        if (banner.isSuccess) {
          setBannerList(banner.getValue())
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      } catch (e) {
        setIsLoading(false)
      }
    }

    getData()
  }, [])

  return (
    <section className="sm:bg-primary-grey sm:py-[60px] relative bg-white py-3.5">
      <Container className="relative">
        {isLoading ? (
          <Skeleton
            sizes="w-full sm:h-[28.5vw] h-[30vw]"
            className={clsx("  skeleton-box sm:rounded-[30px]", " rounded")}
          />
        ) : (
          <Carousel
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            arrows={false}
            showDots={true}
            renderDotsOutside
            renderButtonGroupOutside
            customDot={<SliderDot />}
            customButtonGroup={
              screenWidth > 576 ? (
                <SliderArrow length={bannerList.length} displayedSlide={1} />
              ) : (
                <></>
              )
            }
            dotListClass={clsx("!relative sm:pt-10", "!pt-[18px]")}
            containerClass="relative"
          >
            {bannerList.map((value, index) => (
              <a
                href={value.banner_link}
                target={value.banner_link_type === "INTERNAL" ? "_self" : "_blank"}
                rel="noreferrer"
                key={index}
              >
                <Image
                  alt={value.banner_name}
                  src={value.banner_image_path}
                  className={clsx(
                    "w-full object-cover sm:h-[28.5vw] sm:rounded-[30px]",
                    "h-[30vw] rounded"
                  )}
                  width={1280}
                  height={300}
                />
              </a>
            ))}
          </Carousel>
        )}
      </Container>
    </section>
  )
}
